import { Tab, Tabs } from "@mui/material";
import { useHistory } from "react-router-dom";

import { SETTINGS_TABS, SETTINGS_TAB_LABELS } from "./helpers";

import { analyticsTrack } from "../../../../helpers/analytics";

const SettingsTabs = ({ activeTab }) => {
  const history = useHistory();

  const onChange = (_, newTab) => {
    if (newTab === activeTab) {
      return;
    }
    analyticsTrack("explorer_settings_tab_switched", {
      tab: newTab,
      previousTab: activeTab
    });
    history.push({
      pathname: "/explorer/dashboard/settings",
      search: `?tab=${newTab}`
    });
  };

  return (
    <Tabs
      value={activeTab}
      onChange={onChange}
      variant="scrollable"
      scrollButtons="auto"
      sx={{ minHeight: 40, "& .MuiTab-root": { minHeight: 40, py: 1 } }}
    >
      {SETTINGS_TABS.map((tab) => (
        <Tab key={tab} value={tab} label={SETTINGS_TAB_LABELS[tab]} />
      ))}
    </Tabs>
  );
};

export default SettingsTabs;
